import { QuestionStyles } from '@vision/ui/interfaces';

export const QUESTION_STYLES_WITH_OPTIONS: QuestionStyles[] = [
  'plain',
  'radio',
  'score',
  'checklist',
  'matrix',
  'star',
  'dropdown',
  'hidden_validation',
  'gender',
  'ranking',
  'random',
  'ces',
];
